import { addDays, format as formatDate, parseISO, startOfWeek } from 'date-fns';

export const formatSlotLabel = (value: string): string => {
  const [hourString, minuteString] = value.split(':');
  const hour = Number(hourString);
  const minute = minuteString ? minuteString : '00';
  if (Number.isNaN(hour)) return value;
  const period = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${hour12.toString()}:${minute.padStart(2, '0')} ${period}`;
};

export const normalizeSlotTime = (value: string): string => {
  const [hourString = '', minuteString = '00'] = value.split(':');
  const hour = Number(hourString);
  const minute = Number(minuteString);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return value.trim();
  return `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
};

export const getNextWeekday = (): string => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  while (date.getDay() === 0 || date.getDay() === 6) {
    date.setDate(date.getDate() + 1);
  }
  return formatDate(date, 'yyyy-MM-dd');
};

export const getWeekStart = (value: string): string => {
  const parsed = parseISO(value);
  if (Number.isNaN(parsed.valueOf())) {
    return formatDate(startOfWeek(new Date(), { weekStartsOn: 0 }), 'yyyy-MM-dd');
  }
  return formatDate(startOfWeek(parsed, { weekStartsOn: 0 }), 'yyyy-MM-dd');
};

export const getWeekDates = (weekStart: string): string[] => {
  const start = parseISO(weekStart);
  return Array.from({ length: 7 }, (_value, index) =>
    formatDate(addDays(start, index), 'yyyy-MM-dd'),
  );
};

export const buildBaseTimes = (startHour: number, endHour: number): string[] => {
  const times: string[] = [];
  for (let hour = startHour; hour <= endHour; hour += 1) {
    times.push(`${hour.toString().padStart(2, '0')}:00`);
  }
  return times;
};

export const formatDayLabel = (date: string): string => {
  const parsed = parseISO(date);
  if (Number.isNaN(parsed.valueOf())) return date;
  return formatDate(parsed, 'EEE MMM d');
};
